"use strict";Object.defineProperty(exports, "__esModule", {value: true});// "/" typed into an empty field opens Templates (lane D). Mid-sentence "/"
// ("and/or") stays literal, so only the first character of an empty field
// counts. The character stays in the field either way.


 const detectTypedTrigger = (previous, next) =>
  previous === '' && next === '/' ? '/' : null; exports.detectTypedTrigger = detectTypedTrigger
